import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchData(ctx, id) {
            return new Promise((resolve, reject) => {
              axios
                .get('/portfolios/v1/block/getall/'+id)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        UpdateOrder(ctx, queryParams) {
            var data = JSON.stringify(queryParams.items);    
            return new Promise((resolve, reject) => {
              axios
                .put('/portfolios/v1/block/updateOrdering/'+queryParams.id,data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addBlock(ctx, queryParams) {
          //  var data = JSON.stringify(queryParams);   
          //  console.log("1",queryParams) 
          //  console.log("2",data) 

            return new Promise((resolve, reject) => {
              axios
                .post('/portfolios/v1/block/add',queryParams)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        UpdateBlock(ctx, queryParams) {
            
            return new Promise((resolve, reject) => {
              axios
                .put('/portfolios/v1/block/update/'+queryParams.id,queryParams.formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        deleteBlock(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                  .delete('/portfolios/v1/block/delete/'+id)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })

        }
    }
}